module.exports = __webpack_public_path__ + "static/media/bookfair.22287f47.JPG";